'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _Misc = require('@/helpers/Misc');

var Misc = _interopRequireWildcard(_Misc);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            title: 'Where are you connecting today?',
            buttonText: '',
            server_type: 'default',
            server: '',
            tls: false,
            nick: '',
            password: '',
            encoding: 'utf8',
            channel: '',
            znc_network: '',
            znc_network_support: true,
            direct: false,
            direct_path: '',
            show_type_switcher: true,
            show_password_box: false,
            is_connecting: false,
            network: null
        };
    },
    created: function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var saveThisSessionsState, network, fragment, uriCheck, connections, con;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            saveThisSessionsState = false;

                            if (_state2.default.networks.length > 0) {
                                network = _state2.default.networks[0];

                                _state2.default.setActiveBuffer(network.id, network.serverBuffer().name);
                                saveThisSessionsState = true;
                                this.$emit('start');
                            } else if (window.location.hash.substr(1)) {
                                fragment = window.location.hash.substr(1);
                                uriCheck = fragment.substr(0, 7).toLowerCase();

                                if (uriCheck === 'ircs%3a' || uriCheck.substr(0, 6) === 'irc%3a') {
                                    fragment = decodeURIComponent(fragment);
                                }

                                connections = Misc.parseIrcUri(fragment);

                                if (connections.length === 0) {
                                    saveThisSessionsState = true;
                                    this.applyDefaults();
                                } else if (connections.length === 1) {
                                    saveThisSessionsState = false;
                                    this.server_type = 'default_simple';
                                    this.show_type_switcher = false;

                                    con = connections[0];

                                    this.server = con.server + ':' + con.port;
                                    this.tls = con.tls;
                                    this.nick = this.processNickRandomNumber(con.nick);
                                    this.channel = con.channels.join(',');
                                    this.direct = con.direct;
                                    this.encoding = con.encoding;

                                    if (con.params.type === 'znc') {
                                        if (con.params.network === '_') {
                                            this.znc_network_support = false;
                                        } else {
                                            this.znc_network = con.params.network || '';
                                        }
                                        this.server_type = 'znc';
                                        this.title = 'Enter your password to connect to ZNC';
                                    } else {
                                        this.title = 'Enter a nickname to join';
                                    }
                                } else if (connections.length > 1) {
                                    saveThisSessionsState = false;

                                    connections.forEach(function (con, idx) {
                                        var net = _state2.default.addNetwork(con.server, con.nick, {
                                            server: con.server,
                                            port: con.port,
                                            tls: con.tls,
                                            password: con.password || ''
                                        });

                                        con.channels.forEach(function (channelName) {
                                            var buffer = _state2.default.addBuffer(net.id, channelName);
                                            buffer.enabled = true;
                                        });

                                        if (idx === 0) {
                                            _state2.default.setActiveBuffer(net.id, net.serverBuffer().name);
                                        }
                                    });

                                    this.$emit('start');
                                }
                            } else {
                                saveThisSessionsState = true;
                                this.applyDefaults();
                            }

                            if (_state2.default.settings.startupOptions.greetingText) {
                                this.title = _state2.default.settings.startupOptions.greetingText;
                            }
                            if (_state2.default.settings.startupOptions.buttonText) {
                                this.buttonText = _state2.default.settings.startupOptions.buttonText;
                            } else {
                                this.buttonText = this.$t('connect');
                            }

                            if (saveThisSessionsState) {
                                _state2.default.persistence.watchStateForChanges();
                            }

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref.apply(this, arguments);
        }

        return created;
    }(),
    methods: {
        readableStateError: function readableStateError(err) {
            return Misc.networkErrorMessage(err);
        },

        startUp: function startUp() {
            var _this = this;

            var net = void 0;

            if (!this.nick) {
                this.$el.querySelector('.kiwi-customserver-nick input').focus();
                return;
            }

            var nick = this.nick;

            if (this.server_type === 'znc') {
                var password = nick;
                if (this.znc_network) {
                    password += '/' + this.znc_network;
                }
                password += ':' + this.password;

                net = _state2.default.addNetwork('ZNC', 'ZNC', {
                    server: this.server.split(':')[0],
                    port: parseInt(this.server.split(':')[1] || 6667, 10),
                    tls: this.tls,
                    password: password
                });
            } else {
                net = _state2.default.addNetwork('Network', nick, {
                    server: this.server.split(':')[0],
                    port: parseInt(this.server.split(':')[1] || 6667, 10),
                    tls: this.tls,
                    password: this.password,
                    direct: this.direct,
                    path: this.direct_path,
                    encoding: this.encoding
                });
            }

            if (net) {
                var hasSetActiveBuffer = false;

                var bufferObjs = Misc.extractBuffers(this.channel);
                bufferObjs.forEach(function (bufferObj, idx) {
                    var buffer = _state2.default.addBuffer(net.id, bufferObj.name);
                    buffer.enabled = true;

                    if (bufferObj.key) {
                        buffer.key = bufferObj.key;
                    }

                    if (idx === 0) {
                        _state2.default.setActiveBuffer(net.id, buffer.name);
                        hasSetActiveBuffer = true;
                    }
                });

                if (!hasSetActiveBuffer) {
                    _state2.default.setActiveBuffer(net.id, net.serverBuffer().name);
                }

                this.is_connecting = true;
                this.network = net;
                net.ircClient.connect();

                var onRegistered = function onRegistered() {
                    setTimeout(function () {
                        _this.is_connecting = false;
                    }, 1000);
                    _this.$emit('start');
                    net.ircClient.off('registered', onRegistered);
                    net.ircClient.off('close', onClosed);
                };
                var onClosed = function onClosed() {
                    setTimeout(function () {
                        _this.is_connecting = false;
                    }, 1000);
                    net.ircClient.off('registered', onRegistered);
                    net.ircClient.off('close', onClosed);
                };
                net.ircClient.once('registered', onRegistered);
                net.ircClient.once('close', onClosed);
            }
        },
        processNickRandomNumber: function processNickRandomNumber(nick) {
            var tmp = (nick || '').replace(/\?/g, function () {
                return Math.floor(Math.random() * 100).toString();
            });
            return _lodash2.default.trim(tmp);
        },
        infoClick: function infoClick() {
            if (this.network) {
                var net = this.network;
                _state2.default.setActiveBuffer(net.id, net.serverBuffer().name);
            }
            this.$emit('start');
        },
        applyDefaults: function applyDefaults() {
            this.server = _state2.default.settings.startupOptions.server;
            this.tls = _state2.default.settings.startupOptions.tls;
            this.nick = this.processNickRandomNumber(_state2.default.settings.startupOptions.nick);
            this.channel = _state2.default.settings.startupOptions.channel;
            this.direct = _state2.default.settings.startupOptions.direct;
            this.direct_path = _state2.default.settings.startupOptions.direct_path;
            this.encoding = _state2.default.settings.startupOptions.encoding;

            if (_state2.default.settings.startupOptions.port.toString() !== '6667') {
                this.server += ':' + _state2.default.settings.startupOptions.port.toString();
            }

            this.title = 'Where are you connecting today?';
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["CustomServer"]
window._kiwi_exports.components.startups.CustomServer = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/startups/CustomServer.vue
// module id = 8LRQ
// module chunks = 1